import { useDispatch } from 'react-redux';
import { useFormField } from 'hook/form.hook';
import { getSsnMasker } from 'helpers/signup.helpers';

export const useSsnForm = (fullSsn, cleanSsnError, noDispatch) => {
  const dispatch = useDispatch();
  const [ssn, setSsnInternal] = useFormField('', null, getSsnMasker(fullSsn));

  const handleSsnChange = e => {
    const val = e.target.value.trim();
    if (val.length > ssn.label.length) {
      const newChar = val.charAt(val.length - 1);
      const newVal = ssn.value + newChar;

      if (/^\d*$/.test(newVal)) {
        setSsnInternal(newVal);
      }
    } else if (val.length < ssn.label.length) {
      const subtractedCharacters = ssn.label.length - val.length;
      let charactersToRemove = subtractedCharacters;

      if (ssn.label.length > 6 && val.length <= 6) {
        charactersToRemove -= 1;
      }

      if (fullSsn && ssn.label.length > 3 && val.length <= 3) {
        charactersToRemove -= 1;
      }

      if (subtractedCharacters > ssn.value.length) {
        charactersToRemove = ssn.value.length;
      }

      setSsnInternal(
        ssn.value.substring(0, ssn.value.length - charactersToRemove),
      );
    }
    if (noDispatch) {
      cleanSsnError();
    } else {
      dispatch(cleanSsnError());
    }
  };

  return {
    ssn,
    setSsnInternal,
    ssnError: ssn.error,
    handleSsnChange,
  };
};
